import React, { createContext, useContext, useEffect, useState } from 'react'
import { useCheckMaticLowBalance } from 'src/hooks/settings/use-check-matic-low-balance.hook'
import { useUser } from 'src/hooks'
import { EUserRoles } from 'src/types'

interface LowBalanceNotificationContextType {
  isBannerVisible: boolean
  balance: number | null
}

const LowBalanceNotificationContext = createContext<LowBalanceNotificationContextType | undefined>(
  undefined,
)

export const LowBalanceNotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data, isLoading } = useCheckMaticLowBalance()
  const { data: user, isFetching } = useUser()
  const [isBannerVisible, setIsBannerVisible] = useState<boolean>(false)
  const [balance, setBalance] = useState<number | null>(null)

  useEffect(() => {
    if (!isLoading && data && user?.roles.includes(EUserRoles.superadmin)) {
      setIsBannerVisible(data.lowBalanceStatus)
      setBalance(data.balance)
    } else {
      setIsBannerVisible(false)
      setBalance(null)
    }
  }, [isLoading, data, user, isFetching])

  return (
    <LowBalanceNotificationContext.Provider value={{ isBannerVisible, balance }}>
      {children}
    </LowBalanceNotificationContext.Provider>
  )
}

export const useLowBalanceNotification = () => {
  const context = useContext(LowBalanceNotificationContext)
  if (context === undefined) {
    throw new Error(
      'useLowBalanceNotification must be used within a LowBalanceNotificationProvider',
    )
  }
  return context
}
